import { Component } from '@angular/core';

@Component({
  selector: 'app-salesman-analysis',
  standalone: false,
  
  templateUrl: './salesman-analysis.component.html',
  styles: ``
})
export class SalesmanAnalysisComponent {

}
